export default "__VITE_ASSET__BMtX42uq__"